import FullscreenOverlay from '../../../applications/dialogs/fullscreenoverlay';

import attention from './assets/attention.png';

import { GlobalContext } from '../../../utils/globalprovider';

import React from 'react';
import './simplePopup.css';

import Icon from '../icone/icon';

class PopupBoutons extends React.Component {
  static contextType = GlobalContext;

  onKeyDown(event, button) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();

      button.onclick();
      return;
    }

    this.props.onKeyDown(event);
  }

  render() {
    var buttons = this.props.buttons;
    if (buttons === null) buttons = [];

    if (buttons.length === 0) {
      buttons = [
        { text: { fr: 'Ok', en: 'Ok' }, onclick: this.props.onCancel },
      ];
    }

    var retour = [];

    const lang = this.context.language;

    console.log('boutons ', buttons);

    for (var i = 0; i < buttons.length; i++) {
      const button = buttons[i];

      retour.push(
        <button
          key={'button-' + i}
          className="Simplemodal-button"
          onClick={button.onclick}
          onKeyDown={(event) => this.onKeyDown(event, button)}
        >
          <span>{lang === 'fr' ? button.text.fr : button.text.en}</span>
        </button>
      );
    }
    return retour;
  }
}

class SimplePopup extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    //if (this.props.onCancel) this.onCancel = this.props.onCancel();

    this.onCancel = this.onCancel.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.trapFocusElements = this.trapFocusElements.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.display !== this.props.display) {
      // on set le focus sur le premier bouton
      if (this.props.display) {
        const element = document.querySelector('.SimplePopupdarkBG button');

        if (element) {
          element.focus();
        }
      }
    }
  }

  onCancel() {
    if (this.props.onCancel) this.props.onCancel();
  }

  onKeyDown(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (
      event.key === 'Enter' &&
      event.target.className === 'SimpleModalcloseBtn'
    ) {
      event.preventDefault();
      event.stopPropagation();
      
      this.onCancel();

      return;
    }

    if (event.key === 'Tab') {
   
      
      const parentElement = document.querySelector('.SimplePopupdarkBG');
      const currentElement = document.activeElement;

      this.trapFocusElements(
        parentElement,
        currentElement,
        'button, [role="button"]',
        event.shiftKey
      );

      return;
    }
  }

  // ***************************************************************************************
  // trapFocusElements permet de tabuler sur les éléments qu'on veut focused
  // ***************************************************************************************
  trapFocusElements(parentElement, currentElement, selector, shiftKey) {
    // Obtenir tous les éléments focusables dans le component
    const elements = parentElement.querySelectorAll(selector);

    if (!elements.length) {
      return;
    }

    // Trouver l'index de l'élément focusé dans la liste des boutons
    const currentIndex = Array.prototype.indexOf.call(elements, currentElement);

    let nextIndex;

    if (shiftKey) {
      nextIndex = (currentIndex - 1) % elements.length;

      if (nextIndex === -1) {
        nextIndex = elements.length - 1;
      }
    } else {
      nextIndex = (currentIndex + 1) % elements.length;
    }

    var nextButton = elements[nextIndex];
    if (nextButton) {
      nextButton.focus();
    }
  }

  render() {
    const lang = this.context.language;
    if (this.props.display !== true) return <></>;

    var filter = { filter: localStorage.getItem('default-icon-simplemodal') };

    var titlefr = this.props.title.fr;
    var titleen = this.props.title.en;
    if (titlefr === '' || this.props.title === '') {
      titlefr = 'O.T.T.O.';
      titleen = 'O.T.T.O.';
    }

    var text = lang === 'fr' ? this.props.text.fr : this.props.text.en

    text = text +"\r\n";

    const formatted = text.split(/\r?\n/).map((line, i) => (
        <React.Fragment key={i}>
          {line}
          <br />
        </React.Fragment>
      ));    


    return (
      <FullscreenOverlay>
      <div className="SimplePopupdarkBG" role='dialog'  aria-labelledby="modalTitle">
        <div className="SimplePopupcentered">
          <div className="SimplePopupmodal">
            <div className="SimpleModalmodalHeader">
              <p className="SimpleModalheading" id="modalTitle">
                {lang === 'fr' ? titlefr : titleen}
              </p>
            </div>
            <button
              className="SimpleModalcloseBtn"
              title={lang === 'fr' ? 'Fermer' : 'Close'}
              onClick={this.onCancel}
              onKeyDown={this.onKeyDown}
            >
              <span aria-hidden="true">x</span>
            </button>
            <div className="SimplemodalContent-icon">
              <img
                alt=""
                style={filter}
                src={attention}
                height={64}
                width={64}
                border={false}
              />
            </div>
            <div className="SimplemodalContent">
              <div className="SimplemodalContent-text">
                {formatted}
              </div>
            </div>
            <div className="Simplemodal-div-buttons">
              <PopupBoutons
                buttons={this.props.buttons}
                onCancel={this.onCancel}
                onKeyDown={this.onKeyDown}
              />
            </div>
          </div>
        </div>
      </div>
      </FullscreenOverlay>

    );
  }
}

SimplePopup.defaultProps = {
  display: false,
  onCancel: null,
};

export default SimplePopup;
